// extracted by mini-css-extract-plugin
export default {"loginWrapper":"LoginForm_loginWrapper__3MSR5","formItem":"LoginForm_formItem__WrlYq"};